import React, { PureComponent } from 'react'
import i18n from 'i18next'
import AnimateHeight from 'react-animate-height'
import { observer } from 'mobx-react'
import * as R from 'ramda'

import SingleAxis from './ReportQuestions/SingleAxis'
import NumberRange from './ReportQuestions/NumberRange'
import Priority from './ReportQuestions/Priority'
import NumberForm from './ReportQuestions/NumberForm'
import DoubleAxis from './ReportQuestions/DoubleAxis'
import Percent from './ReportQuestions/Percent'
import TextQuestion from './ReportQuestions/TextQuestion'
import TextListBox from './ReportQuestions/TextListBox'
import ReportPageHeader from './ReportPageHeader'
import UrlVariable from './ReportQuestions/UrlVariable'
import SmartGrid from './ReportQuestions/SmartGrid'
import Panel from '../../../../UniformComponents/Panel'
import QuestionEdit from './QuestionEdit'
import Button from '../../../../UniformComponents/Button'

@observer
class ReportPage extends PureComponent {
    toggleOpen = () => {
        const { reportStore, page } = this.props
        reportStore.openPages.set(page.id, !reportStore.openPages.get(page.id))
    }

    renderResponseEdit = (surveyId, pageId) => {
        const { store, reportStore } = this.props

        if (!reportStore.emSurveyUser) return null

        const surveyPageURL = `${store.survey.getUserLink(reportStore.emSurveyUser, true)}&pageId=${pageId}&noCache=1&pageOnly=true`
        return (
            <div
                style={{ marginLeft: '5px' }}
            >
                <Button
                    className="regular primary"
                    onClick={() => this.setState({ editAnswersModalIsOpen: true, editAnswersURL: surveyPageURL })}
                    label={i18n.t('report_updateAnswers')}
                />
            </div>
        )
    }

    getQuestionElements = () => {
        const {
            store,
            reportFilter,
            page,
            locale,
            showDebug,
            scrollTop,
            reportStore,
        } = this.props
        return page.questions.map((question) => {
            let elem = null
            const {
                questionTypeCode, formId, pageQuestionId, questionId,
            } = question
            const dataKey = formId
                ? `${formId}_${questionId}`
                : pageQuestionId
            const editAnswers = (
                <QuestionEdit
                    reportStore={reportStore}
                    pageId={page.id}
                />
            )
            if (R.pathOr(false, ['settings', 'report', 'graphType'], question)
             && !['bar', 'column', 'line', 'area'].includes(question.settings.report.graphType)) {
                question.settings.report.graphType = 'column'
            }

            if (questionTypeCode === 'I') {
                elem = (
                    <NumberRange
                        pageId={page.id}
                        store={store}
                        data={reportStore.reportDataV2.questions[dataKey]}
                        dataKey={dataKey}
                        pageQuestionId={question.pageQuestionId}
                        reportDataFetched={reportStore.reportDataFetched}
                        question={question}
                        reportFilter={reportFilter}
                        locale={locale}
                        showDebug={showDebug}
                        scrollTop={scrollTop}
                        reportStore={reportStore}
                        editQuestionResponse={editAnswers}
                    />
                )
            } else if (questionTypeCode === 'OD') {
                elem = (
                    <Priority
                        pageId={page.id}
                        store={store}
                        data={reportStore.reportDataV2.questions[dataKey]}
                        dataKey={dataKey}
                        pageQuestionId={question.pageQuestionId}
                        reportDataFetched={reportStore.reportDataFetched}
                        question={question}
                        reportFilter={reportFilter}
                        locale={locale}
                        showDebug={showDebug}
                        scrollTop={scrollTop}
                        reportStore={reportStore}
                        editQuestionResponse={editAnswers}
                    />
                )
            } else if (questionTypeCode === 'PC') {
                elem = (
                    <Percent
                        pageId={page.id}
                        store={store}
                        data={reportStore.reportDataV2.questions[dataKey]}
                        dataKey={dataKey}
                        pageQuestionId={question.pageQuestionId}
                        reportDataFetched={reportStore.reportDataFetched}
                        question={question}
                        reportFilter={reportFilter}
                        locale={locale}
                        showDebug={showDebug}
                        scrollTop={scrollTop}
                        reportStore={reportStore}
                        editQuestionResponse={editAnswers}
                    />
                )
            } else if (['RT', 'TB'].includes(questionTypeCode)) {
                elem = (
                    <DoubleAxis
                        pageId={page.id}
                        store={store}
                        data={reportStore.reportDataV2.questions[dataKey]}
                        dataKey={dataKey}
                        pageQuestionId={question.pageQuestionId}
                        reportDataFetched={reportStore.reportDataFetched}
                        question={question}
                        reportFilter={reportFilter}
                        locale={locale}
                        showDebug={showDebug}
                        scrollTop={scrollTop}
                        reportStore={reportStore}
                        editQuestionResponse={editAnswers}
                    />
                )
            } else if (['SG'].includes(questionTypeCode)) {
                elem = (
                    <SmartGrid
                        pageId={page.id}
                        store={store}
                        data={reportStore.reportDataV2.questions[dataKey]}
                        dataKey={dataKey}
                        pageQuestionId={question.pageQuestionId}
                        reportDataFetched={reportStore.reportDataFetched}
                        question={question}
                        reportFilter={reportFilter}
                        locale={locale}
                        showDebug={showDebug}
                        scrollTop={scrollTop}
                        reportStore={reportStore}
                        editQuestionResponse={editAnswers}
                    />
                )
            } else if (['TA', 'TX', 'DT'].includes(questionTypeCode)) {
                elem = (
                    <TextQuestion
                        pageId={page.id}
                        store={store}
                        data={reportStore.reportDataV2.questions[dataKey]}
                        reportFilter={reportFilter}
                        dataKey={dataKey}
                        locale={locale}
                        pageQuestionId={question.pageQuestionId}
                        question={question}
                        showDebug={showDebug}
                        scrollTop={scrollTop}
                        reportStore={reportStore}
                        editQuestionResponse={editAnswers}
                    />
                )
            } else if (['TL'].includes(questionTypeCode)) {
                elem = (
                    <TextListBox
                        pageId={page.id}
                        store={store}
                        data={reportStore.reportDataV2.questions[dataKey]}
                        dataKey={dataKey}
                        pageQuestionId={question.pageQuestionId}
                        question={question}
                        reportFilter={reportFilter}
                        locale={locale}
                        showDebug={showDebug}
                        scrollTop={scrollTop}
                        reportStore={reportStore}
                        editQuestionResponse={editAnswers}
                    />
                )
            } else if (['UV'].includes(questionTypeCode)) {
                console.log(dataKey, JSON.stringify(reportStore.reportData.questions, null, 4))
                elem = (
                    <UrlVariable
                        pageId={page.id}
                        store={store}
                        data={reportStore.reportDataV2.questions[dataKey]}
                        dataKey={dataKey}
                        pageQuestionId={question.pageQuestionId}
                        question={question}
                        reportFilter={reportFilter}
                        locale={locale}
                        showDebug={showDebug}
                        scrollTop={scrollTop}
                        reportStore={reportStore}
                        editQuestionResponse={editAnswers}
                    />
                )
            } else if (questionTypeCode === 'NF') {
                elem = (
                    <NumberForm
                        pageId={page.id}
                        store={store}
                        data={reportStore.reportDataV2.questions[dataKey]}
                        dataKey={dataKey}
                        pageQuestionId={question.pageQuestionId}
                        reportDataFetched={reportStore.reportDataFetched}
                        question={question}
                        reportFilter={reportFilter}
                        locale={locale}
                        showDebug={showDebug}
                        scrollTop={scrollTop}
                        reportStore={reportStore}
                        editQuestionResponse={editAnswers}
                    />
                )
            } else if (!['ST', 'FM'].includes(questionTypeCode)) {
                elem = (
                    <SingleAxis
                        pageId={page.id}
                        store={store}
                        data={reportStore.reportDataV2.questions[dataKey]}
                        pageQuestionId={question.pageQuestionId}
                        question={question}
                        dataKey={dataKey}
                        reportDataFetched={reportStore.reportDataFetched}
                        reportFilter={reportFilter}
                        locale={locale}
                        showDebug={showDebug}
                        scrollTop={scrollTop}
                        reportStore={reportStore}
                        editQuestionResponse={editAnswers}
                    />
                )
            }
            return (
                elem
            )
        })
    }

    render() {
        const {
            page, index, reportStore, store,
        } = this.props
        const isOpen = reportStore.openPages.get(page.id)
        return (
            <Panel cssClass={`toggle_${page.id}`} style={{ position: 'relative' }}>
                {reportStore.showQuickFilter && <div className="page-overlay" />}
                <ReportPageHeader
                    toggleOpen={this.toggleOpen}
                    isOpen={isOpen}
                    reportStore={reportStore}
                    page={page}
                    pageIndex={index}
                    isMaxbi={store.survey.isMaxbi()}
                />
                <AnimateHeight
                    style={{ zIndex: 100 }}
                    duration={250}
                    height={isOpen ? 'auto' : 0} // see props documentation below
                >
                    <div
                        style={{
                            padding: '16px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '25px',
                        }}
                    >
                        {this.getQuestionElements()}
                    </div>
                </AnimateHeight>
            </Panel>
        )
    }
}

export default ReportPage
